import { writable } from "svelte/store"
import type { VisualizationData } from "./data-source-interface";


/**
 * Store for visualization data
 */
function createDataStore() {
	const { subscribe, set, update } = writable( [] as VisualizationData[]);

	return {
    /** Get the value of store */
		subscribe,
    /** Set the value of store */
    set,
    /** Update the data collection (store) */
    updateCollection: (inputValue: VisualizationData) => {
      update((n: VisualizationData[]) => {
        const existingIndex = n.findIndex((item) => item.id === inputValue.id);
        if (existingIndex !== -1) {
          // Remove the old object with duplicated ID
          n.splice(existingIndex, 1);
        }
        // Add the new object and sort the collection
        n.push(inputValue);
        // Sort the collection by ID
        n.sort((a, b) => parseInt(a.id.split("-")[a.id.split("-").length - 1]) - parseInt(b.id.split("-")[b.id.split("-").length - 1]));
        return n;
      });
    },
    /** Remove single object from data collection (store) */
    removeVisualization: (dataId: string) => {
      update((n: VisualizationData[]) => {
        const existingIndex = n.findIndex((item) => item.id === dataId);
        if (existingIndex !== -1) {
          // Remove the old object with duplicated ID
          n.splice(existingIndex, 1);
        }
        return n;
      });
    },
    /**
    Update "size" variable in store.
    Since size attribute is not a part of views, but a part of visualization container
    we need to update it separately.
    */
    updateVisualizationSize: (dataId: string, visualizationSize: string) => {
      update((n: VisualizationData[]) => {
        const existingIndex = n.findIndex((item) => item.id === dataId);
        if (existingIndex !== -1) {
          n[existingIndex].visualizationSize = visualizationSize;
        }
        return n;
      });
    },
    resetStore: () => set([]),
	};
}

export const visualizationDataStore = createDataStore();

/* Get data from local storage */
const storedData = localStorage.getItem('visualizationDataCollection');
const parsedData = storedData ? JSON.parse(storedData) : null;

/* Update store with data from local storage */
if (parsedData === null) {} else{
  for (let i = 0; i < parsedData.length; i++) {
    visualizationDataStore.updateCollection(parsedData[i]);
  }
}

/* Subscribe to store changes and save them to local storage */
visualizationDataStore.subscribe((value) => localStorage.visualizationDataCollection = JSON.stringify(value));


/**
 * Store for handling visualization headers
 */
function createHeaderStore() {
  const { subscribe, set, update } = writable();

  return {
    subscribe,
    set,
    updateHeader: (inputValue: boolean) => {
      update(() => inputValue);
    },
  };
}

export const showHeaderStore = createHeaderStore();

/**
 * Store for dictionary entries and drawer state
 */
function createDictionaryStore() {
  const { subscribe, set, update } = writable({
    entries: [] as any[],
    search: "",
    open: false,
  });

  return {
    subscribe,
    setEntries: (entries: any[]) => update((state) => ({ ...state, entries })),
    setSearch: (search: string) => update((state) => ({ ...state, search })),
    openDictionary: () =>
      update((state) => ({ ...state, open: true })),
    closeDictionary: () =>
      update((state) => ({
        ...state,
        open: false,
      })),
    reset: () => set({ entries: [], search: "", open: false }),
  };
}

export const dictionaryStore = createDictionaryStore();
